var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !this.$store.state.loadingDaycoRoles
    ? _c(
        "v-container",
        { staticClass: "white py-0 pb-5", attrs: { fluid: "" } },
        [
          _vm.getDaycoRolesDataFailed
            ? _c(
                "v-card",
                { attrs: { elevation: "0" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass:
                        "modal-title white--text d-flex align-center",
                      staticStyle: {
                        position: "sticky",
                        "z-index": "15",
                        top: "0"
                      }
                    },
                    [
                      _c("v-col", { attrs: { cols: "11" } }, [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "d-flex align-center font-weight-regular"
                          },
                          [
                            _c("v-icon", { attrs: { dark: "" } }, [
                              _vm._v("mdi-delete")
                            ]),
                            _vm._v("Error ")
                          ],
                          1
                        )
                      ]),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex flex-row-reverse",
                          attrs: { cols: "1" }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: { dark: "" },
                              on: {
                                click: function($event) {
                                  return _vm.closeDialog(false, "", "")
                                }
                              }
                            },
                            [_vm._v("mdi-close")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "d-flex justify-center align-center" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "background-failure d-flex align-center justify-center"
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    size: "200",
                                    color: "rgb(150,150,150)"
                                  }
                                },
                                [_vm._v("mdi-alert-circle")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-flex justify-center align-center display-1",
                            staticStyle: { "text-align": "center" }
                          },
                          [_vm._v(" " + _vm._s(_vm.finishedText) + " ")]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : !_vm.daycoRolTransactionFinished
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "modal-title white--text d-flex justify-space-between align-center",
                      staticStyle: {
                        position: "sticky",
                        "z-index": "15",
                        top: "0"
                      },
                      attrs: { cols: "12" }
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "d-flex align-center font-weight-regular"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("mdi-clipboard-text")
                          ]),
                          _vm._v(" Gestión de Roles ")
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          attrs: { dark: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeDialog(false, "", "")
                            }
                          }
                        },
                        [_vm._v("mdi-close")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-stepper",
                        {
                          staticClass: "elevation-0 mb-n5 px-2",
                          model: {
                            value: _vm.currentStep,
                            callback: function($$v) {
                              _vm.currentStep = $$v
                            },
                            expression: "currentStep"
                          }
                        },
                        [
                          _c(
                            "v-stepper-header",
                            { staticClass: "elevation-0" },
                            [
                              [
                                _c(
                                  "v-avatar",
                                  {
                                    staticClass:
                                      "d-flex align-self-center justify-self-center justify-center ;",
                                    staticStyle: { "z-index": "2" },
                                    attrs: {
                                      color:
                                        1 == _vm.currentStep
                                          ? "rgb(25, 58, 81)"
                                          : "white",
                                      size: 1 == _vm.currentStep ? 64 : 50
                                    }
                                  },
                                  [
                                    _c("v-stepper-step", {
                                      class:
                                        this.$vuetify.breakpoint.width > 960
                                          ? "ml-4"
                                          : "",
                                      staticStyle: {
                                        transform: "scale(2)",
                                        "z-index": "2",
                                        opacity: "1"
                                      },
                                      attrs: {
                                        complete: _vm.currentStep > 1,
                                        step: 1,
                                        color: "#94CA4E"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                1 !== _vm.steps
                                  ? _c("v-progress-linear", {
                                      key: 1,
                                      staticClass:
                                        "d-flex align-self-center px-12 mr-12",
                                      staticStyle: {
                                        position: "absolute",
                                        display: "inline",
                                        "z-index": "1"
                                      },
                                      attrs: { color: "green", value: "100" }
                                    })
                                  : _vm._e()
                              ],
                              [
                                _c(
                                  "v-avatar",
                                  {
                                    staticClass:
                                      "d-flex align-self-center justify-self-center justify-center ;",
                                    staticStyle: { "z-index": "2" },
                                    attrs: {
                                      color:
                                        2 == _vm.currentStep
                                          ? "rgb(25, 58, 81)"
                                          : "white",
                                      size: 2 == _vm.currentStep ? 64 : 50
                                    }
                                  },
                                  [
                                    _c("v-stepper-step", {
                                      class:
                                        this.$vuetify.breakpoint.width > 960
                                          ? "ml-4"
                                          : "",
                                      staticStyle: {
                                        transform: "scale(2)",
                                        "z-index": "2",
                                        opacity: "1"
                                      },
                                      attrs: {
                                        complete: _vm.currentStep > 2,
                                        step: 2,
                                        color: "#94CA4E"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                2 !== _vm.steps
                                  ? _c("v-progress-linear", {
                                      staticClass:
                                        "d-flex align-self-center px-12 mr-12",
                                      staticStyle: {
                                        position: "absolute",
                                        display: "inline",
                                        "z-index": "1"
                                      },
                                      attrs: { color: "green", value: "100" }
                                    })
                                  : _vm._e()
                              ]
                            ],
                            2
                          ),
                          _c(
                            "v-stepper-items",
                            [
                              _c(
                                "v-stepper-content",
                                { attrs: { step: "1" } },
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c("h2", { staticClass: "text--black" }, [
                                        _vm._v("Grupos del Directorio Activo")
                                      ]),
                                      this.privilegesAD.c ||
                                      this.privilegesAD.u ||
                                      this.privilegesAD.d
                                        ? _c(
                                            "h5",
                                            { staticClass: "text--black" },
                                            [_vm._v(" (Selecciona un grupo) ")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-card",
                                                { staticClass: "elevation-0" },
                                                [
                                                  _c(
                                                    "v-card-title",
                                                    [
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    "prepend-inner-icon":
                                                                      "mdi-magnify",
                                                                    label:
                                                                      "Buscar",
                                                                    "single-line":
                                                                      "",
                                                                    "hide-details":
                                                                      ""
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.search,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.search = $$v
                                                                    },
                                                                    expression:
                                                                      "search"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-data-table", {
                                                    attrs: {
                                                      headers: _vm.headers,
                                                      page: _vm.page,
                                                      items: _vm.daycoGroups,
                                                      "items-per-page": 5,
                                                      "items-per-page-options": [
                                                        5,
                                                        10
                                                      ],
                                                      "footer-props": {
                                                        itemsPerPageOptions: [
                                                          5,
                                                          10
                                                        ],
                                                        itemsPerPageText:
                                                          "Cantidad de grupos por página",
                                                        prevIcon: "",
                                                        nextIcon: "",
                                                        pageText: ""
                                                      },
                                                      "no-data-text":
                                                        "No hay grupos disponibles",
                                                      search: _vm.search
                                                    },
                                                    on: {
                                                      "update:page": function(
                                                        $event
                                                      ) {
                                                        _vm.page = $event
                                                      },
                                                      "page-count": function(
                                                        $event
                                                      ) {
                                                        _vm.pages = $event
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "no-data",
                                                          fn: function() {
                                                            return [
                                                              _vm._v(
                                                                " No hay grupos disponibles "
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        },
                                                        {
                                                          key: "no-results",
                                                          fn: function() {
                                                            return [
                                                              _vm._v(
                                                                " No se encontraron resultados "
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        },
                                                        {
                                                          key: "item.action",
                                                          fn: function(ref) {
                                                            var item = ref.item
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  attrs: {
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.editItem(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " mdi-pencil "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.fireWarning(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-delete"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        },
                                                        {
                                                          key: "header.name",
                                                          fn: function(ref) {
                                                            var header =
                                                              ref.header
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "center !important"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        header.text
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        },
                                                        {
                                                          key: "item",
                                                          fn: function(ref) {
                                                            var item = ref.item
                                                            return [
                                                              _c(
                                                                "tr",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.selectGroup(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "text-xs-right"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item.name
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "text-xs-right"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item.description
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "text-center"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-chip",
                                                                        {
                                                                          staticClass:
                                                                            "text-center",
                                                                          attrs: {
                                                                            color: item.mapped
                                                                              ? "green"
                                                                              : "gray",
                                                                            dark:
                                                                              "",
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.mapped
                                                                                ? item.rolName
                                                                                : "No posee rol asociado"
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      1469111653
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "blue-grey lighten-4 ma-0 py-2"
                                                },
                                                [
                                                  _c("v-pagination", {
                                                    attrs: {
                                                      length: _vm.pages,
                                                      "total-visible": 7
                                                    },
                                                    model: {
                                                      value: _vm.page,
                                                      callback: function($$v) {
                                                        _vm.page = $$v
                                                      },
                                                      expression: "page"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                { attrs: { step: "2" } },
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-window",
                                        {
                                          model: {
                                            value: _vm.rolWindowIndex,
                                            callback: function($$v) {
                                              _vm.rolWindowIndex = $$v
                                            },
                                            expression: "rolWindowIndex"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-window-item",
                                            { attrs: { value: 1 } },
                                            [
                                              !_vm.daycoRolTransaction
                                                ? _c(
                                                    "v-form",
                                                    { ref: "form1" },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          class:
                                                            this.$vuetify
                                                              .breakpoint
                                                              .name === "sm"
                                                              ? "mx-n11"
                                                              : ""
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-flex"
                                                            },
                                                            [
                                                              !_vm.daycoRolTransaction
                                                                ? _c(
                                                                    "h2",
                                                                    {
                                                                      staticClass:
                                                                        "text--black"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Asociación de Rol "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-flex justify-center mt-3",
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "h3",
                                                                {
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "center"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .selectedGroup
                                                                          .name
                                                                          ? _vm
                                                                              .selectedGroup
                                                                              .name
                                                                          : "Selecciona un grupo"
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "elevation-2 mx-3",
                                                          staticStyle: {
                                                            "border-radius":
                                                              "1%"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "mt-n7",
                                                                      attrs: {
                                                                        cols:
                                                                          "12"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("br"),
                                                                      _c(
                                                                        "v-row",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-col",
                                                                            {
                                                                              attrs: {
                                                                                cols:
                                                                                  "10"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "h3",
                                                                                {
                                                                                  staticClass:
                                                                                    "ml-2 text--black"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Rol "
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm
                                                                                .selectedGroup
                                                                                .mapped
                                                                                ? _c(
                                                                                    "h5",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text--black"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " (Rol actual: " +
                                                                                          _vm._s(
                                                                                            _vm.daycoRolName
                                                                                          ) +
                                                                                          ") "
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-col",
                                                                            {
                                                                              attrs: {
                                                                                cols:
                                                                                  "1"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "v-col",
                                                                            {
                                                                              attrs: {
                                                                                cols:
                                                                                  "1"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm
                                                                                .selectedGroup
                                                                                .mapped
                                                                                ? _c(
                                                                                    "v-menu",
                                                                                    {
                                                                                      key:
                                                                                        _vm.menuGroupKey,
                                                                                      attrs: {
                                                                                        "offset-y":
                                                                                          "",
                                                                                        "offset-x":
                                                                                          "",
                                                                                        left:
                                                                                          "",
                                                                                        "offset-overflow":
                                                                                          "",
                                                                                        "close-on-content-click": false,
                                                                                        disabled: !_vm.menuGroup
                                                                                      },
                                                                                      scopedSlots: _vm._u(
                                                                                        [
                                                                                          {
                                                                                            key:
                                                                                              "activator",
                                                                                            fn: function(
                                                                                              ref
                                                                                            ) {
                                                                                              var on =
                                                                                                ref.on
                                                                                              return [
                                                                                                _vm
                                                                                                  .privilegesAD
                                                                                                  .d &&
                                                                                                _vm
                                                                                                  .selectedGroup
                                                                                                  .mapped
                                                                                                  ? _c(
                                                                                                      "v-icon",
                                                                                                      _vm._g(
                                                                                                        {
                                                                                                          on: {
                                                                                                            click: function(
                                                                                                              $event
                                                                                                            ) {
                                                                                                              return _vm.openGroupDeletionMenu()
                                                                                                            }
                                                                                                          }
                                                                                                        },
                                                                                                        on
                                                                                                      ),
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          "mdi-delete"
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e()
                                                                                              ]
                                                                                            }
                                                                                          }
                                                                                        ],
                                                                                        null,
                                                                                        false,
                                                                                        495092406
                                                                                      ),
                                                                                      model: {
                                                                                        value:
                                                                                          _vm.menuGroup,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.menuGroup = $$v
                                                                                        },
                                                                                        expression:
                                                                                          "menuGroup"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-card",
                                                                                        [
                                                                                          _c(
                                                                                            "v-container",
                                                                                            [
                                                                                              _c(
                                                                                                "v-row",
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-col",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "d-flex justify-center"
                                                                                                    },
                                                                                                    [
                                                                                                      !_vm.deletingGroup
                                                                                                        ? _c(
                                                                                                            "h2",
                                                                                                            {
                                                                                                              staticStyle: {
                                                                                                                "text-align":
                                                                                                                  "center"
                                                                                                              }
                                                                                                            },
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                " ¿No asociar rol a este grupo? "
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        : _c(
                                                                                                            "v-progress-circular",
                                                                                                            {
                                                                                                              attrs: {
                                                                                                                size: 40,
                                                                                                                width: 3,
                                                                                                                color:
                                                                                                                  "success",
                                                                                                                indeterminate:
                                                                                                                  ""
                                                                                                              }
                                                                                                            }
                                                                                                          )
                                                                                                    ],
                                                                                                    1
                                                                                                  )
                                                                                                ],
                                                                                                1
                                                                                              ),
                                                                                              _c(
                                                                                                "v-row",
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-col",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "d-flex flex-row-reverse justify-center"
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "v-btn",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "mr-7",
                                                                                                          attrs: {
                                                                                                            outlined:
                                                                                                              "",
                                                                                                            color:
                                                                                                              "green"
                                                                                                          },
                                                                                                          on: {
                                                                                                            click: function(
                                                                                                              $event
                                                                                                            ) {
                                                                                                              _vm.menuGroup = false
                                                                                                            }
                                                                                                          }
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "Cancelar"
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "v-btn",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "mr-7",
                                                                                                          attrs: {
                                                                                                            dark:
                                                                                                              "",
                                                                                                            color:
                                                                                                              "green"
                                                                                                          },
                                                                                                          on: {
                                                                                                            click: function(
                                                                                                              $event
                                                                                                            ) {
                                                                                                              return _vm.deleteGroup()
                                                                                                            }
                                                                                                          }
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "No asociar rol"
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ],
                                                                                                    1
                                                                                                  )
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : _vm._e()
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "v-autocomplete",
                                                                        {
                                                                          key:
                                                                            _vm.rolOptionsKey,
                                                                          attrs: {
                                                                            items:
                                                                              _vm.daycoRoles,
                                                                            "auto-select-first":
                                                                              "",
                                                                            "item-value":
                                                                              "id",
                                                                            "item-text":
                                                                              "role.name",
                                                                            rules:
                                                                              _vm
                                                                                .rules
                                                                                .rolRules,
                                                                            "no-data-text":
                                                                              "No se encontraron resultados",
                                                                            color:
                                                                              "blue-grey lighten-2",
                                                                            label:
                                                                              "Selecciona un rol",
                                                                            "single-line":
                                                                              ""
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm.daycoRol,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.daycoRol = $$v
                                                                            },
                                                                            expression:
                                                                              "daycoRol"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "template",
                                                                            {
                                                                              slot:
                                                                                "prepend-inner"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  staticClass:
                                                                                    "mr-3",
                                                                                  attrs: {
                                                                                    color:
                                                                                      "green"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-clipboard-text"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        2
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-row",
                                                                [
                                                                  _c("v-col", {
                                                                    attrs: {
                                                                      cols: "8"
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex flex-row-reverse",
                                                                      attrs: {
                                                                        cols:
                                                                          "4"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm
                                                                        .privileges
                                                                        .c
                                                                        ? _c(
                                                                            "v-btn",
                                                                            {
                                                                              staticClass:
                                                                                "mx-2 white--text ml-7",
                                                                              attrs: {
                                                                                color:
                                                                                  "green"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.changeWindowCreateRol(
                                                                                    2
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " Crear Rol "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm
                                                                        .privileges
                                                                        .r
                                                                        ? _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs: {
                                                                                disabled:
                                                                                  !_vm.daycoRol ||
                                                                                  _vm.daycoRol ===
                                                                                    -1
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.changeWindow(
                                                                                    2
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " Ver detalle de Rol "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : !_vm.daycoRolTransactionFinished
                                                ? _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-center align-center",
                                                          attrs: { cols: "12" }
                                                        },
                                                        [
                                                          _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                size: 200,
                                                                width: 7,
                                                                color:
                                                                  "success",
                                                                indeterminate:
                                                                  ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "green",
                                                                    size: 50
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-clipboard-text"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-flex justify-center align-center display-1",
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.loadingText
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-window-item",
                                            {
                                              key: _vm.windowKey,
                                              attrs: { value: 2 }
                                            },
                                            [
                                              _c(
                                                "v-form",
                                                { ref: "formRoles" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    { staticClass: "ma-2" },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "elevation-2",
                                                          attrs: { cols: "12" }
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "d-flex"
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "9"
                                                                  }
                                                                },
                                                                [
                                                                  _c("h2", [
                                                                    _vm._v(
                                                                      "Gestión de Roles"
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "1"
                                                                  }
                                                                },
                                                                [
                                                                  _vm.privileges
                                                                    .u &&
                                                                  !_vm.createRol &&
                                                                  !_vm.isRolAdministrator(
                                                                    _vm
                                                                      .currentRol
                                                                      .id
                                                                  )
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            color: _vm.editRol
                                                                              ? "green"
                                                                              : "none"
                                                                          },
                                                                          on: {
                                                                            click:
                                                                              _vm.rolEdition
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-pencil"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "1"
                                                                  }
                                                                },
                                                                [
                                                                  !_vm.createRol &&
                                                                  !_vm.isRolAdministrator(
                                                                    _vm
                                                                      .currentRol
                                                                      .id
                                                                  )
                                                                    ? _c(
                                                                        "v-menu",
                                                                        {
                                                                          key:
                                                                            _vm.menuKey,
                                                                          attrs: {
                                                                            "offset-y":
                                                                              "",
                                                                            "offset-x":
                                                                              "",
                                                                            left:
                                                                              "",
                                                                            "offset-overflow":
                                                                              "",
                                                                            "close-on-content-click": false,
                                                                            disabled: !_vm.menu
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "activator",
                                                                                fn: function(
                                                                                  ref
                                                                                ) {
                                                                                  var on =
                                                                                    ref.on
                                                                                  return [
                                                                                    _vm
                                                                                      .privileges
                                                                                      .d &&
                                                                                    !_vm.loadingDeleteRolButton
                                                                                      ? _c(
                                                                                          "v-icon",
                                                                                          _vm._g(
                                                                                            {
                                                                                              on: {
                                                                                                click: function(
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.openRolDeletionMenu(
                                                                                                    _vm
                                                                                                      .currentRol
                                                                                                      .id,
                                                                                                    _vm
                                                                                                      .currentRol
                                                                                                      .name
                                                                                                  )
                                                                                                }
                                                                                              }
                                                                                            },
                                                                                            on
                                                                                          ),
                                                                                          [
                                                                                            _vm._v(
                                                                                              "mdi-delete"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _c(
                                                                                          "v-progress-circular",
                                                                                          {
                                                                                            attrs: {
                                                                                              size: 30,
                                                                                              width: 3,
                                                                                              color:
                                                                                                "success",
                                                                                              indeterminate:
                                                                                                ""
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            false,
                                                                            1183504585
                                                                          ),
                                                                          model: {
                                                                            value:
                                                                              _vm.menu,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.menu = $$v
                                                                            },
                                                                            expression:
                                                                              "menu"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-card",
                                                                            [
                                                                              _c(
                                                                                "v-container",
                                                                                [
                                                                                  _c(
                                                                                    "v-row",
                                                                                    [
                                                                                      _c(
                                                                                        "v-col",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-flex justify-center"
                                                                                        },
                                                                                        [
                                                                                          !_vm.deletingRol
                                                                                            ? _c(
                                                                                                "h2",
                                                                                                {
                                                                                                  staticStyle: {
                                                                                                    "text-align":
                                                                                                      "center"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " ¿Eliminar rol? "
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            : _c(
                                                                                                "v-progress-circular",
                                                                                                {
                                                                                                  attrs: {
                                                                                                    size: 40,
                                                                                                    width: 3,
                                                                                                    color:
                                                                                                      "success",
                                                                                                    indeterminate:
                                                                                                      ""
                                                                                                  }
                                                                                                }
                                                                                              )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                  _c(
                                                                                    "v-row",
                                                                                    [
                                                                                      _c(
                                                                                        "v-col",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-flex flex-row-reverse justify-center"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-btn",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mr-7",
                                                                                              attrs: {
                                                                                                outlined:
                                                                                                  "",
                                                                                                color:
                                                                                                  "green"
                                                                                              },
                                                                                              on: {
                                                                                                click: function(
                                                                                                  $event
                                                                                                ) {
                                                                                                  _vm.menu = false
                                                                                                }
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Cancelar"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "v-btn",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mr-7",
                                                                                              attrs: {
                                                                                                dark:
                                                                                                  "",
                                                                                                color:
                                                                                                  "green"
                                                                                              },
                                                                                              on: {
                                                                                                click: function(
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.deleteRol()
                                                                                                }
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Eliminar"
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "1"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.changeWindow(
                                                                            1
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-close"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "mx-2"
                                                            },
                                                            [
                                                              !_vm.createRol
                                                                ? _c(
                                                                    "v-autocomplete",
                                                                    {
                                                                      attrs: {
                                                                        items:
                                                                          _vm.daycoRoles,
                                                                        "auto-autocomplete-first":
                                                                          "",
                                                                        "item-value":
                                                                          "id",
                                                                        "item-text":
                                                                          "role.name",
                                                                        "no-data-text":
                                                                          "No se encontraron resultados",
                                                                        color:
                                                                          "blue-grey lighten-2",
                                                                        label:
                                                                          "Selecciona un rol",
                                                                        outlined:
                                                                          "",
                                                                        disabled:
                                                                          _vm.editRol
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.daycoRol,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.daycoRol = $$v
                                                                        },
                                                                        expression:
                                                                          "daycoRol"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "template",
                                                                        {
                                                                          slot:
                                                                            "prepend-inner"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticClass:
                                                                                "mr-3",
                                                                              attrs: {
                                                                                color:
                                                                                  "green"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-clipboard-text"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    2
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "mx-2"
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "Nombre de rol",
                                                                    rules:
                                                                      _vm.rules
                                                                        .defaultRules,
                                                                    readonly:
                                                                      !_vm.createRol &&
                                                                      !_vm.editRol,
                                                                    counter: "",
                                                                    maxlength:
                                                                      "100"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentRol
                                                                        .name,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.currentRol,
                                                                        "name",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "currentRol.name"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "mx-2"
                                                            },
                                                            [
                                                              _c("v-textarea", {
                                                                attrs: {
                                                                  rules:
                                                                    _vm.rules
                                                                      .defaultRules,
                                                                  label:
                                                                    "Descripcion",
                                                                  outlined: "",
                                                                  counter: "",
                                                                  maxlength:
                                                                    "200",
                                                                  readonly:
                                                                    !_vm.createRol &&
                                                                    !_vm.editRol
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .currentRol
                                                                      .description,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.currentRol,
                                                                      "description",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "currentRol.description"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-row",
                                                            [
                                                              _c(
                                                                "v-col",
                                                                [
                                                                  _c(
                                                                    "v-simple-table",
                                                                    {
                                                                      attrs: {
                                                                        "fixed-header":
                                                                          "",
                                                                        height:
                                                                          "390px"
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "default",
                                                                            fn: function() {
                                                                              return [
                                                                                _c(
                                                                                  "thead",
                                                                                  [
                                                                                    _c(
                                                                                      "tr",
                                                                                      [
                                                                                        _c(
                                                                                          "th",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              "text-align":
                                                                                                "center"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-row",
                                                                                              [
                                                                                                _c(
                                                                                                  "v-col",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "d-flex justify-center ml-n5",
                                                                                                    attrs: {
                                                                                                      cols:
                                                                                                        "6"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "v-checkbox",
                                                                                                      {
                                                                                                        attrs: {
                                                                                                          readonly:
                                                                                                            !_vm.createRol &&
                                                                                                            !_vm.editRol
                                                                                                        },
                                                                                                        model: {
                                                                                                          value:
                                                                                                            _vm.setAllPrivilegesValue,
                                                                                                          callback: function(
                                                                                                            $$v
                                                                                                          ) {
                                                                                                            _vm.setAllPrivilegesValue = $$v
                                                                                                          },
                                                                                                          expression:
                                                                                                            "\n                                                                                            setAllPrivilegesValue\n                                                                                        "
                                                                                                        }
                                                                                                      }
                                                                                                    )
                                                                                                  ],
                                                                                                  1
                                                                                                ),
                                                                                                _c(
                                                                                                  "v-col",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "d-flex flex-row-reverse aling-center mt-6 ml-0",
                                                                                                    attrs: {
                                                                                                      cols:
                                                                                                        "6"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "Funcionalidades"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                        _c(
                                                                                          "th",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              "text-align":
                                                                                                "center"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-col",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-flex justify-center"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Consultar"
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                        _c(
                                                                                          "th",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              "text-align":
                                                                                                "center"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-col",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-flex justify-center"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Crear"
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                        _c(
                                                                                          "th",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              "text-align":
                                                                                                "center"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-col",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-flex justify-center"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Modificar"
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                        _c(
                                                                                          "th",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              "text-align":
                                                                                                "center"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-col",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-flex justify-center"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Eliminar"
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "tbody",
                                                                                  _vm._l(
                                                                                    _vm.privilegeList,
                                                                                    function(
                                                                                      privilege,
                                                                                      index
                                                                                    ) {
                                                                                      return _c(
                                                                                        "tr",
                                                                                        {
                                                                                          key: index
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "td",
                                                                                            {
                                                                                              staticStyle: {
                                                                                                "text-align":
                                                                                                  "center"
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    privilege.resourceName
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _c(
                                                                                                "v-col",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "d-flex justify-center"
                                                                                                },
                                                                                                [
                                                                                                  privilege
                                                                                                    .read
                                                                                                    .privilegeId !==
                                                                                                    -1 &&
                                                                                                  privilege.resourceId !==
                                                                                                    3 &&
                                                                                                  privilege.resourceId !==
                                                                                                    10
                                                                                                    ? _c(
                                                                                                        "v-checkbox",
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            readonly:
                                                                                                              !_vm.createRol &&
                                                                                                              !_vm.editRol
                                                                                                          },
                                                                                                          model: {
                                                                                                            value:
                                                                                                              privilege
                                                                                                                .read
                                                                                                                .active,
                                                                                                            callback: function(
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                privilege.read,
                                                                                                                "active",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                            expression:
                                                                                                              "\n                                                                                        privilege\n                                                                                            .read\n                                                                                            .active\n                                                                                    "
                                                                                                          }
                                                                                                        }
                                                                                                      )
                                                                                                    : _vm._e()
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _c(
                                                                                                "v-col",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "d-flex justify-center"
                                                                                                },
                                                                                                [
                                                                                                  privilege
                                                                                                    .create
                                                                                                    .privilegeId !==
                                                                                                    -1 &&
                                                                                                  privilege.resourceId !==
                                                                                                    6 &&
                                                                                                  privilege.resourceId !==
                                                                                                    2 &&
                                                                                                  privilege.resourceId !==
                                                                                                    9 &&
                                                                                                  privilege.resourceId !==
                                                                                                    1 &&
                                                                                                  privilege.resourceId !==
                                                                                                    4
                                                                                                    ? _c(
                                                                                                        "v-checkbox",
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            readonly:
                                                                                                              !_vm.createRol &&
                                                                                                              !_vm.editRol
                                                                                                          },
                                                                                                          model: {
                                                                                                            value:
                                                                                                              privilege
                                                                                                                .create
                                                                                                                .active,
                                                                                                            callback: function(
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                privilege.create,
                                                                                                                "active",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                            expression:
                                                                                                              "\n                                                                                        privilege\n                                                                                            .create\n                                                                                            .active\n                                                                                    "
                                                                                                          }
                                                                                                        }
                                                                                                      )
                                                                                                    : _vm._e()
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _c(
                                                                                                "v-col",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "d-flex justify-center"
                                                                                                },
                                                                                                [
                                                                                                  privilege
                                                                                                    .update
                                                                                                    .privilegeId !==
                                                                                                    -1 &&
                                                                                                  privilege.resourceId !==
                                                                                                    1
                                                                                                    ? _c(
                                                                                                        "v-checkbox",
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            readonly:
                                                                                                              !_vm.createRol &&
                                                                                                              !_vm.editRol
                                                                                                          },
                                                                                                          model: {
                                                                                                            value:
                                                                                                              privilege
                                                                                                                .update
                                                                                                                .active,
                                                                                                            callback: function(
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                privilege.update,
                                                                                                                "active",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                            expression:
                                                                                                              "\n                                                                                        privilege\n                                                                                            .update\n                                                                                            .active\n                                                                                    "
                                                                                                          }
                                                                                                        }
                                                                                                      )
                                                                                                    : _vm._e()
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _c(
                                                                                                "v-col",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "d-flex justify-center"
                                                                                                },
                                                                                                [
                                                                                                  privilege
                                                                                                    .delete
                                                                                                    .privilegeId !==
                                                                                                    -1 &&
                                                                                                  privilege.resourceId !==
                                                                                                    1
                                                                                                    ? _c(
                                                                                                        "v-checkbox",
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            readonly:
                                                                                                              !_vm.createRol &&
                                                                                                              !_vm.editRol
                                                                                                          },
                                                                                                          model: {
                                                                                                            value:
                                                                                                              privilege
                                                                                                                .delete
                                                                                                                .active,
                                                                                                            callback: function(
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                privilege.delete,
                                                                                                                "active",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                            expression:
                                                                                                              "\n                                                                                        privilege\n                                                                                            .delete\n                                                                                            .active\n                                                                                    "
                                                                                                          }
                                                                                                        }
                                                                                                      )
                                                                                                    : _vm._e()
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    }
                                                                                  ),
                                                                                  0
                                                                                )
                                                                              ]
                                                                            },
                                                                            proxy: true
                                                                          }
                                                                        ],
                                                                        null,
                                                                        false,
                                                                        3953753992
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-row",
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "d-flex flex-row-reverse"
                                                                },
                                                                [
                                                                  (_vm.createRol ||
                                                                    _vm.editRol) &&
                                                                  (_vm
                                                                    .privileges
                                                                    .c ||
                                                                    _vm
                                                                      .privileges
                                                                      .u)
                                                                    ? _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "mr-7",
                                                                          attrs: {
                                                                            dark:
                                                                              "",
                                                                            color:
                                                                              "green",
                                                                            loading:
                                                                              _vm.rolTransaction
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.submitRol()
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Guardar"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.daycoRolTransaction && !_vm.daycoRolTransactionFinished
                    ? _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end align-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.rolWindowIndex !== 2,
                                  expression: "rolWindowIndex !== 2"
                                }
                              ],
                              staticClass: "mr-2",
                              attrs: { color: "green", outlined: "" },
                              on: {
                                click: function($event) {
                                  return _vm.closeDialog(false, "", "")
                                }
                              }
                            },
                            [_vm._v("Cancelar")]
                          ),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.rolWindowIndex !== 2 &&
                                    _vm.currentStep !== 1,
                                  expression:
                                    "rolWindowIndex !== 2 && currentStep !== 1"
                                }
                              ],
                              staticClass: "white--text mr-2",
                              attrs: { color: "green" },
                              on: {
                                click: function($event) {
                                  return _vm.previousStep(_vm.currentStep)
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-chevron-left")]),
                              _vm._v("Anterior ")
                            ],
                            1
                          ),
                          _vm.currentStep !== 1 &&
                          _vm.rolWindowIndex !== 2 &&
                          ((_vm.selectedGroup.mapped && _vm.privilegesAD.c) ||
                            (!_vm.selectedGroup.mapped && _vm.privilegesAD.u))
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "white--text mr-2",
                                  attrs: {
                                    color: "green",
                                    disabled:
                                      _vm.selectedGroup.mapped &&
                                      this.initialDaycoRol === this.daycoRol
                                  },
                                  on: { click: _vm.mappGroupAndRol }
                                },
                                [
                                  _vm._v(" Guardar "),
                                  _c("v-icon", { staticClass: "ml-1" }, [
                                    _vm._v("mdi-check-all")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-snackbar",
                    {
                      attrs: {
                        top: "",
                        absolute: "",
                        timeout: 15000,
                        color: _vm.snackbarColor
                      },
                      model: {
                        value: _vm.snackbar,
                        callback: function($$v) {
                          _vm.snackbar = $$v
                        },
                        expression: "snackbar"
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "white", text: "" },
                          on: { click: _vm.closeSnackbar }
                        },
                        [_vm._v(" Cerrar ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }